
import { Component, Vue } from 'vue-property-decorator'
import { queryByVerifyCode, verifyOrder } from '@/api/order'

@Component({
  name: 'WriteOff'
})
export default class extends Vue {
  private verifyCode = ''
  private orderInfo: any = {}
  private verifying = false

  mounted() {
    const queryCode = (this.$route.query.code as string) || ''
    if (queryCode) {
      this.verifyCode = queryCode
      this.handleQuery()
    } else {
      this.focusInput()
    }
  }

  private focusInput() {
    this.$nextTick(() => {
      const input = this.$refs.codeInput as any
      if (input && input.focus) {
        input.focus()
      }
    })
  }

  private async handleQuery() {
    const code = (this.verifyCode || '').trim()
    if (!code) {
      this.$message.warning('请输入核销码')
      this.focusInput()
      return
    }
    try {
      const res: any = await queryByVerifyCode(code)
      if (res && res.data && res.data.code === 1) {
        this.orderInfo = res.data.data || {}
      } else {
        this.orderInfo = {}
        this.$message.error((res && res.data && res.data.msg) || '查询失败')
      }
    } catch (e) {
      this.orderInfo = {}
    }
    this.focusInput()
  }

  private async handleVerify() {
    const code = (this.orderInfo.verifyCode || this.verifyCode || '').trim()
    if (!code) {
      this.$message.warning('请先查询核销码')
      return
    }
    try {
      await this.$confirm('确认核销该卡券？核销后不可撤销', '提示', {
        confirmButtonText: '确认核销',
        cancelButtonText: '取消',
        type: 'warning'
      })
    } catch (e) {
      return
    }

    this.verifying = true
    try {
      const res: any = await verifyOrder(code)
      if (res && res.data && res.data.code === 1) {
        this.$message.success('核销成功')
        await this.handleQuery()
      } else {
        this.$message.error((res && res.data && res.data.msg) || '核销失败')
      }
    } finally {
      this.verifying = false
      this.focusInput()
    }
  }

  private resetForm() {
    this.verifyCode = ''
    this.orderInfo = {}
    this.focusInput()
  }
}
